import { Controller } from "@hotwired/stimulus"

// Toggles [data-accent] on <html> and persists.
// Values:
//   - userId (Number)
//   - accent (String) — black|coral|terracotta|aubergine
export default class extends Controller {
  static values = { userId: Number, accent: String }

  connect() {
    if (!this.accentValue) {
      this.accentValue = document.documentElement.getAttribute("data-accent") || "black"
    }
    this.#apply(this.accentValue)
  }

  pick(event) {
    event?.preventDefault?.()
    const accent = event.currentTarget?.dataset?.accent
    if (!accent) return
    this.accentValue = accent
    this.#apply(accent)
    this.#persist(accent)
  }

  #apply(accent) {
    if (accent === "black") {
      document.documentElement.removeAttribute("data-accent")
    } else {
      document.documentElement.setAttribute("data-accent", accent)
    }
  }

  async #persist(accent) {
    if (!this.hasUserIdValue) return
    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content
      await fetch(`/users/${this.userIdValue}/ui_preferences`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf,
          "Accept": "application/json"
        },
        body: JSON.stringify({ ui_preferences: { accent } })
      })
    } catch (e) {
      console.warn("[accent] persist failed", e)
    }
  }
}
